export const UbuntuDialogContent = () => (
  <ol>
    <li>
      Make the downloaded script executable: <code>chmod +x uptime_ubuntu_deploy_script.sh</code>
    </li>
    <li>
      Run the script: <code>./uptime_ubuntu_deploy_script.sh</code>
    </li>
    <li>Follow the on-screen instructions to complete the installation.</li>
  </ol>
);
